export const DISPLAY_NAME_SYMBOLS = ['SPX-PERP'];
